import { LuCalendar, LuClock7, LuBuilding2, LuMapPin, LuShirt } from "react-icons/lu";
import "../event-detail/event-detail.css"

const items = [
    { icon: LuCalendar, label: "Hari & Tanggal", value: "Sabtu, 27 Juni 2026" },
    { icon: LuClock7, label: "Waktu", value: "17:30 - 21:00 WITA" },
    { icon: LuBuilding2, label: "Lokasi", value: "Swiss-Belhotel Makassar" },
    { icon: LuMapPin, label: "Alamat", value: "Jl. Ujung Pandang No.8, Makassar" },
];

const EventDetail = () => {
    return (
        <section id="event-detail">
            <div className="container">
                <section className="save-date-section">
                    <div className="event-header">
                        <p className="display-title">Save the Date</p>
                        <h2 className="date-title">
                            <span className="date-day">27</span>
                            <span className="date-month">June</span>
                            <span className="date-year">2026</span>
                        </h2>
                    </div>

                    <div className="info-grid">
                        {items.map((it) => (
                            <div key={it.label} className="info-card">
                                <div className="icon-wrapper">
                                    <it.icon className="icon" strokeWidth={1.5} />
                                </div>
                                <div>
                                    <p className="info-label">{it.label}</p>
                                    <p className="info-value">{it.value}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="dress-code">
                        <div className="dress-chip">
                            <LuShirt strokeWidth={1.5} className="text-gold" />
                            <span className="dress-label">Dress Code</span>
                            <span className="dress-value">Nusantara Modern</span>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    );
};

export default EventDetail;